import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';

const sha256 = async (query: string) => {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(query));
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
};

/**
 * APQ(Automatic Persisted Queries) 링크. HttpLink 바로 앞에 위치해야 한다.
 * - 로컬 개발에서는 비활성 — DevTools에서 복사한 curl에 쿼리 전문이 그대로 담기도록 (BE 공유/디버깅 용도)
 * - crypto.subtle이 없는 환경(비 HTTPS LAN 접속 등)에서도 APQ 없이 동작하도록 빈 배열을 반환한다.
 */
export const createApqLink = () => {
  if (process.env.NODE_ENV === 'development') return [];
  return typeof crypto !== 'undefined' && crypto.subtle ? [createPersistedQueryLink({ sha256 })] : [];
};
